import { setInnerTextById, getSubscriptionNameFromDefinition, setSubscriptionNameInUI } from 'CmsManagePreferences/js/utils/common';
import { DOM_CLASS_NAMES, DOM_IDS, HS_EVENT_CODE, HS_EVENT_QUERY_PARAM } from 'CmsManagePreferences/js/utils/constants';
import { getQueryParams } from 'CmsManagePreferences/js/utils/url';
export default function loadConfirmUI({
  unsubscribedFromAll,
  maskedEmail,
  sentDefinition,
  testSend
}) {
  const unsubAllMessage = document.getElementsByName(DOM_CLASS_NAMES.unsubAllConfirmMessage);
  const subConfirmMessage = document.getElementsByName(DOM_CLASS_NAMES.subConfirmMessage);
  const returnContent = document.getElementById(DOM_IDS.returnContent);
  const unsubSurvey = document.getElementById(DOM_IDS.unsubscribeSurvey);
  const confirmationHeader = document.getElementById(DOM_IDS.confirmationHeader);
  const singleSubMessage = document.getElementsByName(DOM_IDS.unsubSingleConfirmMessage);
  if (maskedEmail) {
    setInnerTextById(DOM_IDS.emailPlaceholder, maskedEmail);
  }
  const hasUnsubAllMessage = unsubAllMessage && unsubAllMessage.length > 0;
  const hasSubConfirmMessage = subConfirmMessage && subConfirmMessage.length > 0;
  if (!hasUnsubAllMessage || !hasSubConfirmMessage) {
    return;
  }
  const displayHeading = () => {
    if (confirmationHeader) {
      confirmationHeader.style.display = 'block';
    }
  };
  const displayUnsubAllMessage = () => {
    unsubAllMessage[0].style.display = 'block';
    subConfirmMessage[0].style.display = 'none';
    singleSubMessage[0].style.display = 'none';
  };
  const displayManagePreferencesMessage = () => {
    subConfirmMessage[0].style.display = 'block';
    unsubAllMessage[0].style.display = 'none';
    singleSubMessage[0].style.display = 'none';
  };
  const displaySingleSubscriptionMessage = () => {
    singleSubMessage[0].style.display = 'block';
    subConfirmMessage[0].style.display = 'none';
    unsubAllMessage[0].style.display = 'none';
  };
  const displayReturnToManagePreferencesContent = () => {
    if (returnContent) {
      returnContent.style.display = 'block';
    }
  };
  const displayUnsubSurvey = () => {
    if (unsubSurvey) {
      unsubSurvey.style.display = 'block';
    }
  };
  const searchParams = getQueryParams(HS_EVENT_QUERY_PARAM);
  displayHeading();
  if (searchParams === HS_EVENT_CODE.UNSUBSCRIBE_ALL) {
    displayUnsubAllMessage();
    displayReturnToManagePreferencesContent();
    displayUnsubSurvey();
    return;
  }
  if (searchParams === HS_EVENT_CODE.MANAGE_PREFERENCES) {
    displayManagePreferencesMessage();
    displayReturnToManagePreferencesContent();
    return;
  }
  if (searchParams === HS_EVENT_CODE.UNSUBSCRIBE_SINGLE) {
    displaySingleSubscriptionMessage();
    displayReturnToManagePreferencesContent();
    const hasValidSentDefinition = sentDefinition && Object.keys(sentDefinition).length > 0;
    if (testSend && !hasValidSentDefinition) {
      return;
    }
    const subscriptionName = getSubscriptionNameFromDefinition(sentDefinition);
    if (subscriptionName) {
      setSubscriptionNameInUI(subscriptionName);
    }
    return;
  }

  // Default behavior
  if (unsubscribedFromAll) {
    displayUnsubAllMessage();
    displayUnsubSurvey();
  } else {
    displayManagePreferencesMessage();
  }
  displayReturnToManagePreferencesContent();
  return;
}